import React, { Component } from 'react';
import PDF from 'react-pdf-js';
import { Pagination, Toast } from 'antd-mobile';
import styles from './style.module.less';
import tools from '../../../utils/tools';
import { getFileBold } from '../../../service/chat-service';

class PdfView extends Component {
  constructor(props) {
    super(props);

    document.title = '学习资料详情';

    this.state = {
      total: 0,
      fileData: null,
      selectPage: 1,
    };
  }

  componentDidMount() {
    this.getBlob();
  }

  getBlob = async () => {
    const fileUrl = tools.getQueryString('fileUrl');

    try {
      await getFileBold(fileUrl);
    } catch (e) {
      // console.log(e);
    }
  }

  loadPDFEnd = (page) => {
    this.setState({ total: page });
    Toast.hide();
  };

  handleChangePage = (selectPage) => {
    this.setState({ selectPage });
  }

  render() {
    const { total, selectPage, fileData } = this.state;

    return (
      <div>
        <PDF file={fileData} page={selectPage} onDocumentComplete={this.loadPDFEnd} />
        <div className={styles.pagination}>
          <Pagination
            total={total}
            onChange={this.handleChangePage}
            current={selectPage}
            locale={{
              prevText: <span className={styles.paginationButton}>上页</span>,
              nextText: <span className={styles.paginationButton}>下页</span>,
            }}
          />
        </div>
      </div>
    );
  }
}

export default PdfView;
